export default "__VITE_ASSET__9EB0rDri__"